/**
 * Call this function at the bottom of a switch statement to ensure that all cases are handled.
 */
export const assertUnreachable = (x: never): never => {
  throw new Error("Didn't expect to get here");
};
